import { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axiosInstance from '../../../../Config/axiosInstance';
import { Box, Card, CardContent, Typography, Chip, Button, IconButton, TextField } from "@mui/material";
import EmailIcon from "@mui/icons-material/Email";
import PhoneIcon from "@mui/icons-material/Phone";
import BusinessIcon from '@mui/icons-material/Business';
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import FingerprintIcon from '@mui/icons-material/Fingerprint';
import PersonIcon from '@mui/icons-material/Person';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import EditIcon from '@mui/icons-material/Edit';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import ReceiptIcon from "@mui/icons-material/Receipt";
import ContactPhoneIcon from '@mui/icons-material/ContactPhone';
import DescriptionIcon from '@mui/icons-material/Description';
import VerifiedIcon from '@mui/icons-material/Verified';
import InfoIcon from '@mui/icons-material/Info';
import CategoryIcon from '@mui/icons-material/Category';
import StarIcon from '@mui/icons-material/Star';

import './DetailsSupplier.css';
import EditContacts from '../ContactPersons/EditContacts';
import EvaluationScoreList from '../../../Procurement/EvaluationScoreSupplier/EvaluationScoreList';
import EvaluationSupplierScore from '../../../Procurement/EvaluationScoreSupplier/CreateEvaluationScore';

const SupplierDetails = () => {
    const { id } = useParams();
    const [supplier, setSupplier] = useState(null);
    const [departments, setDepartments] = useState([]);
    const [selectedContact, setSelectedContact] = useState(null);
    const [editOpen, setEditOpen] = useState(false);
    const navigate = useNavigate();

    const [canCreate, setCanCreate] = useState(false);
    const [canEdit, setCanEdit] = useState(false);

    const [openDialog, setOpenDialog] = useState(false);
    const [open, setOpen] = useState(false)
    const [contracts, setContracts] = useState([]);
    const [averageScore, setAverageScore] = useState(null);
    const [purchaseOrder, setPurchaseOrder] = useState([]);
    const [categoriesList, setCategoriesList] = useState([]);
    const [supplierCategories, setSupplierCategories] = useState([]);
    const [allowedDepartments, setAllowedDepartments] = useState([]);
    const [procurementDeptId, setProcurementDeptId] = useState(null);
    const [systemCurrency, setSystemCurrency] = useState('');
    const [currenciesMap, setCurrenciesMap] = useState({});
    // Removed systemCurrencyId since it's not used

    useEffect(() => {
        const requiredPath = "/supplier";
        const storedPermissions = JSON.parse(localStorage.getItem('permissions'));
        const permissions = storedPermissions?.pages || [];

        setCanCreate(permissions.some((page) => new URL(page.url).pathname === requiredPath && page.can_create));
        setCanEdit(permissions.some((page) => new URL(page.url).pathname === requiredPath && page.can_edit));

        axiosInstance.get(`/suppliers/${id}/`)
            .then(response => {
                setSupplier(response.data);

                const departmentIds = response.data.departments;
                if (departmentIds && departmentIds.length > 0) {
                    const requests = departmentIds.map(departmentId =>
                        axiosInstance.get(`/departments/${departmentId}/`)
                    );
                    Promise.all(requests)
                        .then(responses => {
                            const departmentsData = responses.map(res => res.data);
                            setDepartments(departmentsData);
                        })
                        .catch(error => {
                            console.error("Error fetching departments:", error);
                        });
                }
            })
            .catch(error => {
                console.error("Error fetching supplier details:", error);
            });
    }, [id]);

    useEffect(() => {
        axiosInstance.get("/department/user/")
            .then(response => setAllowedDepartments(response.data.map(d => d.value)))
            .catch(error => console.error("Eroare la obtinerea departamentelor permise: ", error));
    }, []);

    useEffect(() => {
        axiosInstance.get("/departments/")
            .then(response => {
                setDepartments(response.data);
                const procurementDept = response.data.find(d => d.name === "Procurement");
                if (procurementDept) setProcurementDeptId(procurementDept.id);
            })
            .catch(error => console.error("Eroare la încărcarea departamentelor:", error));
    }, []);

    const handleEditContact = (contact) => {
        setSelectedContact(contact);
        setEditOpen(true);
    };

    const handleSaveContact = (updatedContact) => {
        const updatedContacts = supplier.contacts.map(contact =>
            contact.id === updatedContact.id ? updatedContact : contact
        );
        setSupplier({ ...supplier, contacts: updatedContacts });
    };

    const handleCloseEdit = () => {
        setEditOpen(false);
    };

    const handleOpen = () => {
        setOpen(true);
    }

    const handleClose = () => {
        setOpen(false)
    }

    const handleOpenList = () => {
        setOpenDialog(true);
    };

    const handleCloseList = () => {
        setOpenDialog(false);
    }

    const refreshAverageScore = () => {
        axiosInstance.get(`/suppliers/${id}/average-score/`)
            .then(response => {
                setAverageScore(response.data.average_score);
            })
            .catch(error => {
                console.error("Error refreshing average score:", error);
            });
    }

    //valuta pentru po
    const fetchCurrencyDetails = async (orders) => {
        const currencyIds = [...new Set(orders.map(order => order.currency).filter(Boolean))];
        const currencyMap = {};
        
        for (const currencyId of currencyIds) {
            try {
                const response = await axiosInstance.get(`/currencies/${currencyId}/`);
                currencyMap[currencyId] = response.data.abbreviation || response.data.name || '';
            } catch (error) {
                console.error(`Error fetching currency ${currencyId}:`, error);
                currencyMap[currencyId] = '';
            }
        }
        setCurrenciesMap(currencyMap);
    };

    useEffect(() => {
        axiosInstance.get(`/suppliers/${id}/`)
            .then(response => {
                setSupplier(response.data);
                setValue(response.data.audited || '-');
                setTempValue(response.data.audited || '-');
            })
            .catch(error => {
                console.error("Error fetching supplier details:", error);
            });

        axiosInstance.get(`/suppliers/${id}/contracts-supplier/`)
            .then(response => {
                setContracts(response.data);
            })
            .catch(error => {
                console.error("Error fetching contracts:", error);
            });

        axiosInstance.get(`/suppliers/${id}/average-score/`)
            .then(response => {
                console.log("Score API response:", response.data);
                const raw = response.data.average_score;
                const score = typeof raw === 'number' ? raw : parseFloat(raw);
                setAverageScore(isNaN(score) ? null : score);
            })

        axiosInstance.get(`/suppliers/${id}/orders/`)
            .then(response => {
                setPurchaseOrder(response.data);
                if (response.data.length > 0) {
                    fetchCurrencyDetails(response.data);
                }
            }).catch(error => {
                console.error("Error fetching orders: ", error);
            })
    }, [id]);

    useEffect(() => {
        axiosInstance.get('/category/')
            .then(response => {
                setCategoriesList(response.data);
            })
            .catch(err => console.error(err));
    }, []);

    useEffect(() => {
        if (supplier && categoriesList.length > 0) {
            const mappedCategories = supplier.category.map(catId => {
                return categoriesList.find(cat => cat.id === catId);
            }).filter(Boolean);

            setSupplierCategories(mappedCategories);
        }
    }, [supplier, categoriesList]);

    //preia system currency din bd
    useEffect(() => {
        const fetchSystemCurrency = async () => {
            try {
                const response = await axiosInstance.get('/system-currency/');
                console.log('System Currency Response:', response.data);
                
                let currencyCode = '';
                
                if (Array.isArray(response.data) && response.data.length > 0) {
                    const systemCurrencyData = response.data[0];
                    console.log('First SystemCurrency:', systemCurrencyData);
                    
                    if (systemCurrencyData.currency) {
                        if (typeof systemCurrencyData.currency === 'object') {
                            currencyCode = systemCurrencyData.currency.abbreviation || 
                                          systemCurrencyData.currency.name || '';
                        } else if (typeof systemCurrencyData.currency === 'number') {
                            try {
                                const currencyRes = await axiosInstance.get(`/currencies/${systemCurrencyData.currency}/`);
                                currencyCode = currencyRes.data.abbreviation || 
                                              currencyRes.data.name || '';
                            } catch (err) {
                                console.error('Error fetching currency:', err);
                            }
                        }
                    }
                } else if (typeof response.data === 'object' && response.data !== null) {
                    const systemCurrencyData = response.data;
                    console.log('SystemCurrency object:', systemCurrencyData);
                    
                    if (systemCurrencyData.currency) {
                        if (typeof systemCurrencyData.currency === 'object') {
                            currencyCode = systemCurrencyData.currency.abbreviation || 
                                          systemCurrencyData.currency.name || '';
                        } else if (typeof systemCurrencyData.currency === 'number') {
                            try {
                                const currencyRes = await axiosInstance.get(`/currencies/${systemCurrencyData.currency}/`);
                                currencyCode = currencyRes.data.abbreviation || 
                                              currencyRes.data.name || '';
                            } catch (err) {
                                console.error('Error fetching currency:', err);
                            }
                        }
                    }
                }
                
                console.log('System Currency Code:', currencyCode);
                setSystemCurrency(currencyCode);
                
            } catch (error) {
                console.error('Error fetching system currency:', error);
                setSystemCurrency('');
            }
        };
        
        fetchSystemCurrency();
    }, []);

    const [isEditing, setIsEditing] = useState(false);
    const [value, setValue] = useState('-');
    const [tempValue, setTempValue] = useState(value);

    const formatContractAmount = (value) => {
        if (value === null || value === undefined || value === '') return '-';

        const numericValue = Number(value);
        if (!Number.isFinite(numericValue)) return '-';

        return new Intl.NumberFormat('ro-RO', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        }).format(numericValue);
    };

    const getContractCurrency = (contract) => {
        if (typeof contract.currency === 'object' && contract.currency !== null) {
            return (
                contract.currency.abbreviation ||
                contract.currency.name ||
                ''
            );
        }

        return (
            contract.currency_abbreviation ||
            contract.currency_name ||
            contract.currency_label ||
            contract.currency_display ||
            ''
        );
    };

    const getContractValue = (contract) => {
        const value =
            contract.total_contract ??
            contract.contract_value ??
            contract.value ??
            contract.value_contract ??
            contract.value_ron;

        const formattedValue = formatContractAmount(value);
        const currency = getContractCurrency(contract);

        return formattedValue === '-' ? '-' : `${formattedValue}${currency ? ` ${currency}` : ''}`;
    };

    // preia pretul cu 2 zecimale si formatul 1.000,25
    const formatPrice = (amount) => {
        if (!amount) return '0,00';
        const number = Number(amount);
        if (isNaN(number)) return '0,00';
        return new Intl.NumberFormat('ro-RO', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        }).format(number);
    };

    // Funcție pentru a extrage codul valutar
    const getCurrencyCode = (currency) => {
        if (!currency) return '';
        
        if (typeof currency === 'string') return currency;
        
        if (typeof currency === 'number') {
            return currenciesMap[currency] || '';
        }
        
        if (typeof currency === 'object' && currency !== null) {
            return currency.abbreviation || currency.name || '';
        }
        
        return '';
    };

    if (!supplier) {
        return <Typography variant="h6">Loading...</Typography>;
    }

    const handleEditClick = () => {
        setTempValue(value);
        setIsEditing(true);
    };

    const handleSave = async () => {
        try {
            const response = await axiosInstance.patch(
                `/suppliers/${supplier.id}/update-audited/`,
                { audited: tempValue }
            );
            setValue(response.data.audited);
            setIsEditing(false);
        } catch (error) {
            console.error('Error updating audited:', error);
            alert('Eroare la actualizare câmp Audited!');
        }
    };

    const handleCancel = () => {
        setTempValue(value);
        setIsEditing(false);
    }

    const getScoreColor = (score) => {
        if (score === null || score === undefined || isNaN(score)) return 'inherit';

        if (score >= 0 && score <= 2) return '#D10000';
        if (score > 2 && score <= 3.5) return '#F5A400';
        if (score > 3.5) return '#10B000';

        return 'inherit';
    };

    return (
        <div className='supplier-details-container'>
            <Box p={3}>
                {/* Header */}
                <div className="supplier-details-header">
                    <ArrowBackIcon className="back-arrow" onClick={() => navigate(-1)} />
                    <h2 className="add-supplier-title">Supplier Details</h2>
                </div>
                <hr className="title-separator" />

                {/* Supplier Name & Status */}
                <div className="supplier-name-section">
                    <Typography variant="h5" gutterBottom style={{ paddingTop: "16px" }}>
                        <span style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                            <BusinessIcon sx={{ color: '#6b7280' }} />
                            {supplier?.name}
                            <Chip 
                                label={supplier?.status} 
                                color={supplier?.status === "Active" ? "success" : "default"} 
                            />
                        </span>
                    </Typography>
                </div>

                {/* Info Table - Non-Procurement view - cu scroll și culori */}
                {procurementDeptId && !allowedDepartments.includes(procurementDeptId) && (
                    <Box className="info-table-wrapper">
                        <div className="table-scroll-wrapper" style={{ border: 'none', margin: 0 }}>
                            <table className="info-table">
                                <tbody>
                                    {[
                                        { label: "Fiscal Code (CUI):", value: supplier.fiscal_code, icon: <FingerprintIcon /> },
                                        { label: "Email:", value: supplier.email, icon: <EmailIcon /> },
                                        { label: "Phone:", value: supplier.phone, icon: <PhoneIcon /> },
                                        { label: "Address:", value: supplier.address, icon: <BusinessIcon /> },
                                        { label: "Register date:", value: new Date(supplier.creation_date).toLocaleDateString(), icon: <CalendarTodayIcon /> }
                                    ].map((item, index) => (
                                        <tr key={index} className="info-row">
                                            <td className="icon-cell">{item.icon}</td>
                                            <td className="label-cell"><strong>{item.label}</strong></td>
                                            <td className="value-cell">{item.value || '-'}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </Box>
                )}

                {/* Contracts Table - Procurement view - cu scroll */}
                {procurementDeptId && allowedDepartments.includes(procurementDeptId) && (
                    <Box className="contracts-table-wrapper">
                        <div className="table-scroll">
                            <table className="contracts-table">
                                <thead>
                                    <tr>
                                        <th>
                                            <DescriptionIcon sx={{ fontSize: 16, verticalAlign: 'middle', mr: 0.5, color: '#6b7280' }} /> 
                                            Contract No.
                                        </th>
                                        <th>Penalties</th>
                                        <th>Payment Due Date</th>
                                        <th>Contract Value</th>
                                        <th>Contract Duration</th>
                                        <th>
                                            <ReceiptIcon sx={{ fontSize: 16, verticalAlign: 'middle', mr: 0.5, color: '#6b7280' }} />
                                            Orders
                                        </th>
                                        <th>
                                            <StarIcon sx={{ fontSize: 16, verticalAlign: 'middle', mr: 0.5, color: '#6b7280' }} />
                                            Evaluation
                                            <EditIcon
                                                style={{ fontSize: 18, verticalAlign: 'middle', marginLeft: 4, cursor: 'pointer', color: '#6b7280' }}
                                                onClick={handleOpen}
                                            />
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {contracts.length > 0 ? (
                                        contracts.map((contract, idx) => (
                                            <tr key={idx} className="contract-row">
                                                <td className="contract-number">{contract.contract_number}</td>
                                                <td>{contract.penalties || '-'}</td>
                                                <td>{contract.payment_terms}</td>
                                                <td>{getContractValue(contract)}</td>
                                                <td>
                                                    {contract.end_date
                                                        ? new Date(contract.end_date).toLocaleDateString()
                                                        : '-'}
                                                </td>
                                                <td>
                                                    {idx === 0 && purchaseOrder.length > 0 ? `${purchaseOrder.length} orders` : ''}
                                                </td>
                                                <td
                                                    onClick={handleOpenList}
                                                    style={{
                                                        cursor: 'pointer',
                                                        color: getScoreColor(averageScore),
                                                        fontWeight: 'bold'
                                                    }}
                                                >
                                                    {idx === 0 && `Score: ${averageScore !== null ? averageScore.toFixed(2) : '-'}`}
                                                </td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan={5}>No contracts</td>
                                            <td>
                                                {purchaseOrder.length > 0 ? `${purchaseOrder.length} orders` : 'No orders'}
                                            </td>
                                            <td
                                                onClick={handleOpenList}
                                                style={{
                                                    cursor: 'pointer',
                                                    color: getScoreColor(averageScore),
                                                    fontWeight: 'bold'
                                                }}
                                            >
                                                Score: {averageScore !== null ? averageScore.toFixed(2) : '-'}
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </Box>
                )}

                {/* Main Layout: Content + Sidebar */}
                <div className="supplier-details-layout">
                    <div className="main-content">
                        {/* Contact Persons Card */}
                        <Card sx={{ mb: 0 }}>
                            <CardContent>
                                <Typography variant="h6">
                                    <ContactPhoneIcon sx={{ color: '#6b7280' }} /> Contact Persons
                                </Typography>
                                {supplier.contacts.filter(contact => contact.contact_status === "Active").length > 0 ? (
                                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                                        {supplier.contacts
                                            .filter(contact => contact.contact_status === "Active")
                                            .map((contact) => (
                                                <Card key={contact.id} variant="outlined" className="contact-card">
                                                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end' }}>
                                                        <Box>
                                                            <div className="contact-header-details">
                                                                <PersonIcon sx={{ color: '#6b7280', fontSize: '16px' }} />
                                                                <Typography variant="h7" sx={{ fontWeight: 'bold' }}>
                                                                    {contact.name}
                                                                </Typography>
                                                                <span className="contact-role">
                                                                    {contact.position}
                                                                </span>
                                                            </div>
                                                            <Typography className="contact-detail">
                                                                <EmailIcon sx={{ mr: 1, color: '#6b7280', verticalAlign: 'middle', fontSize: '16px' }} />
                                                                {contact.email}
                                                            </Typography>
                                                            <Typography className="contact-detail">
                                                                <PhoneIcon sx={{ mr: 1, color: '#6b7280', verticalAlign: 'middle', fontSize: '16px' }} />
                                                                {contact.phone}
                                                            </Typography>
                                                        </Box>
                                                        {(canEdit || canCreate) && (
                                                            <Button
                                                                variant="contained"
                                                                onClick={() => handleEditContact(contact)}
                                                                sx={{ minWidth: '40px', padding: 1, height: 40, alignSelf: 'flex-start' }}
                                                            >
                                                                <EditIcon fontSize="small" />
                                                            </Button>
                                                        )}
                                                    </Box>
                                                </Card>
                                            ))}
                                    </Box>
                                ) : (
                                    <Typography variant="body1" color="textSecondary">
                                        No active contact persons available for this supplier.
                                    </Typography>
                                )}
                            </CardContent>
                        </Card>

                        {/* Audited Card  */}
                        {procurementDeptId && allowedDepartments.includes(procurementDeptId) && (
                            <Card className="audited-card">
                                <CardContent>
                                    <div className="audited-label">
                                        <VerifiedIcon sx={{ fontSize: '20px', color: '#6b7280' }} />
                                        <span>Audited entity</span>
                                    </div>
                                    <div className="audited-actions">
                                        {isEditing ? (
                                            <>
                                                <TextField
                                                    className="audited-input"
                                                    value={tempValue}
                                                    onChange={(e) => setTempValue(e.target.value)}
                                                    size="small"
                                                    variant="outlined"
                                                />
                                                <IconButton 
                                                    className="save-audit-icon" 
                                                    onClick={handleSave}
                                                >
                                                    <CheckIcon />
                                                </IconButton>
                                                <IconButton 
                                                    className="cancel-audit-icon" 
                                                    onClick={handleCancel}
                                                >
                                                    <CloseIcon />
                                                </IconButton>
                                            </>
                                        ) : (
                                            <>
                                                <span className="audited-value">
                                                    {value && value !== '' ? value : '-'}
                                                </span>
                                                <IconButton
                                                    className="edit-audit-icon"
                                                    onClick={handleEditClick}
                                                    size="small"
                                                >
                                                    <EditIcon />
                                                </IconButton>
                                            </>
                                        )}
                                    </div>
                                </CardContent>
                            </Card>
                        )}

                        {/* Last Order Placed Card - cu scroll */}
                        {procurementDeptId && allowedDepartments.includes(procurementDeptId) && (
                            <Card className="last-order-card" sx={{ 
                                mb: 0, 
                                borderRadius: 2,
                                border: '1px solid #e5e7eb'
                            }}>
                                <CardContent sx={{ p: 0 }}>
                                    {/* Header */}
                                    <div className="last-order-header">
                                        <div className="left-section">
                                            <ReceiptIcon sx={{ color: '#6b7280', fontSize: '1.3rem' }} />
                                            <Typography variant="h6">
                                                Last Order Placed
                                            </Typography>
                                        </div>
                                        {purchaseOrder.length > 0 && (
                                            <span className="order-count">
                                                Total: {purchaseOrder.length} orders
                                            </span>
                                        )}
                                    </div>

                                    {purchaseOrder.length > 0 ? (
                                        <div className="order-table-scroll">
                                            {/* Table Header */}
                                            <div className="order-table-header">
                                                <span className="col-order">Order #</span>
                                                <span className="col-total">Total Order</span>
                                                <span className="col-system">System Total Order</span>
                                                <span className="col-date">Date</span>
                                            </div>

                                            {/* Table Rows */}
                                            {purchaseOrder.map((order, index) => {
                                                const currencyCode = getCurrencyCode(order.currency);
                                                
                                                return (
                                                    <div key={index} className="order-row">
                                                        <span className="order-number">#{order.order_number}</span>
                                                        <span className="order-total">
                                                            {formatPrice(order.total)} {currencyCode}
                                                        </span>
                                                        <span className="order-system-total">
                                                            {formatPrice(order.total_system_currency)} {systemCurrency}
                                                        </span>
                                                        <span className="order-date">
                                                            {new Date(order.created_at).toLocaleDateString('en-GB', {
                                                                day: '2-digit',
                                                                month: 'short',
                                                                year: 'numeric',
                                                            })}
                                                        </span>
                                                    </div>
                                                );
                                            })}

                                            {/* Totals Footer */}
                                            {(() => {
                                                const totalsByCurrency = purchaseOrder.reduce((acc, order) => {
                                                    const currencyCode = getCurrencyCode(order.currency) || 'N/A';
                                                    if (!acc[currencyCode]) {
                                                        acc[currencyCode] = 0;
                                                    }
                                                    acc[currencyCode] += Number(order.total) || 0;
                                                    return acc;
                                                }, {});

                                                const systemTotals = purchaseOrder.reduce((acc, order) => {
                                                    acc += Number(order.total_system_currency) || 0;
                                                    return acc;
                                                }, 0);

                                                const currencyEntries = Object.entries(totalsByCurrency);

                                                return (
                                                    <div className="order-totals-footer">
                                                        <span className="total-label" style={{ fontWeight: 'bold' }}>TOTAL</span>
                                                        <div className="total-currencies">
                                                            {currencyEntries.map(([currency, total]) => (
                                                                <span key={currency} style={{ fontWeight: 'bold' }}>
                                                                    {formatPrice(total)} {currency}
                                                                </span>
                                                            ))}
                                                        </div>
                                                        <span className="total-system" style={{ fontWeight: 'bold' }}>
                                                            {formatPrice(systemTotals)} {systemCurrency}
                                                        </span>
                                                        <span className="total-count" style={{ fontWeight: 'bold' }}>
                                                            {purchaseOrder.length} orders
                                                        </span>
                                                    </div>
                                                );
                                            })()}
                                        </div>
                                    ) : (
                                        <Box sx={{ p: 3, textAlign: 'center' }}>
                                            <Typography color="text.secondary" sx={{ fontStyle: 'italic' }}>
                                                No orders found.
                                            </Typography>
                                        </Box>
                                    )}
                                </CardContent>
                            </Card>
                        )}
                    </div>

                    {/* Info Sidebar - Contact Information și Categories */}
                    <div className="info-sidebar">
                        {procurementDeptId && allowedDepartments.includes(procurementDeptId) && (
                            <Card className="sidebar-info-card contact-info-card">
                                <CardContent className="sidebar-card-content">
                                    <div className="section-title">
                                        <InfoIcon sx={{ color: '#6b7280', fontSize: '20px' }} /> 
                                        <span>Contact Information</span>
                                    </div>
                                    <div className="info-item">
                                        <span className="info-label">Email</span>
                                        <span className="info-value">{supplier.email}</span>
                                    </div>
                                    <div className="info-item">
                                        <span className="info-label">Phone</span>
                                        <span className="info-value">{supplier.phone}</span>
                                    </div>
                                    <div className="info-item">
                                        <span className="info-label">Address</span>
                                        <span className="info-value">{supplier.address}</span>
                                    </div>
                                </CardContent>
                            </Card>
                        )}

                        {/* Categories - mai lat */}
                        {procurementDeptId && allowedDepartments.includes(procurementDeptId) && (
                            <Card className="sidebar-info-card categories-info-card">
                                <CardContent className="sidebar-card-content">
                                    <div className="section-title">
                                        <CategoryIcon sx={{ color: '#6b7280', fontSize: '20px' }} /> 
                                        <span>Categories</span>
                                    </div>
                                    <ul className="categories-list">
                                        {supplierCategories.map(category => (
                                            <li key={category.id}>
                                                <span className="category-dot">•</span>
                                                {category.title}
                                            </li>
                                        ))}
                                    </ul>
                                </CardContent>
                            </Card>
                        )}

                        {/* Associated Departments - Non-Procurement view */}
                        {procurementDeptId && !allowedDepartments.includes(procurementDeptId) && (
                            <Card className="sidebar-info-card">
                                <CardContent className="sidebar-card-content">
                                    <div className="section-title">
                                        <BusinessIcon sx={{ color: '#6b7280', fontSize: '20px' }} /> 
                                        <span>Associated Departments</span>
                                    </div>
                                    <Box sx={{ display: "flex", flexWrap: "wrap", gap: "6px" }}>
                                        {departments.map((dept) => (
                                            <span key={dept.id} className="department-chip">
                                                {dept.name}
                                            </span>
                                        ))}
                                    </Box>
                                </CardContent>
                            </Card>
                        )}
                    </div>
                </div>

                {/* Modals */}
                <EditContacts
                    open={editOpen}
                    onClose={handleCloseEdit}
                    contact={selectedContact}
                    onSave={handleSaveContact}
                />

                {open && (
                    <EvaluationSupplierScore
                        open={open}
                        onClose={handleClose}
                        supplierId={supplier?.id}
                        onSaved={refreshAverageScore}
                    />
                )}

                <EvaluationScoreList
                    open={openDialog}
                    onClose={handleCloseList}
                    supplierId={supplier?.id}
                    onSaved={refreshAverageScore}
                />
            </Box>
        </div>
    );
};

export default SupplierDetails;